export const createFormData = (file, nodeRef) => {
  const formData = new FormData();
  formData.append('_assocType', 'ctbd:attachement');
  formData.append('_nodeType', 'ctbd:baseDoc');
  formData.append('_parent', nodeRef);
  formData.append('_content', file, file.name);
  formData.append('prop_cm_name', file.name);
  formData.append('file', file);
  return formData;
};
